import { type ThemeProviderProps } from '@emotion/react'
import { THEME_ID, ThemeProvider, createTheme } from '@mui/material/styles'
import { blueGray, grey, primary } from '../colors'

const materialTheme = createTheme({
  spacing: (factor: number) => `${0.25 * factor}rem`, // follow chakra spacing
  palette: {
    primary,
    grey,
    blueGray,
  },
})

export type FortuneThemeProps = Omit<ThemeProviderProps, 'theme'>

export const FortuneTheme = (props: FortuneThemeProps) => {
  return (
    <ThemeProvider theme={{ [THEME_ID]: materialTheme }} {...props} />
  )
}
